export default __webpack_public_path__ + "static/media/element_27.7c054a79.jpg";